import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'DiscountType';
const ENDPOINT = `/discount-types/`;

@Injectable({
    providedIn: 'root'
})
export class DiscountTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
